import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { currentDomain } from '@bfe/by-dynamic-domain';
import createFetchInstance from '@bfe/by-fetch';
import { sessionStorage } from '@bfe/by-storage';
import weightCalculation from './weight-calculation';
import { ERROR_SPAN_MAX, BASE_SPAN, RECORD_SIZE } from './constants';
var http = createFetchInstance();
export var sendRequest = function sendRequest(host, domain) {
  var start = performance.now();
  return http.get("".concat(host, "/t1")).then(function () {
    var end = performance.now();
    return {
      domain: domain,
      span: end - start
    };
  }).catch(function () {
    return {
      domain: domain,
      span: ERROR_SPAN_MAX
    };
  });
};
var checkApiRTT = function checkApiRTT(servicesMap) {
  var requests = servicesMap.filter(function (_ref) {
    var domain = _ref.domain;
    return domain !== 'auto';
  }).map(function (it) {
    return sendRequest(it.api2, it.domain);
  });
  return Promise.all(requests);
};
var recordStorageKey = 'by_route_record';
var storedRouteRecords = sessionStorage.getObject(recordStorageKey) || {};
export var detectRoute = function detectRoute(servicesMap) {
  return checkApiRTT(servicesMap).then(function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // Discard all invalid data, when network disconnect, all request will failed.
    var isDataAllInvalid = data.every(function (_ref2) {
      var span = _ref2.span;
      return span === -1;
    });
    if (isDataAllInvalid) return '';
    data.forEach(function (_ref3) {
      var domain = _ref3.domain,
        span = _ref3.span;
      var storedRecords = storedRouteRecords[domain];
      if (storedRecords) {
        storedRouteRecords[domain] = [].concat(span, storedRecords).slice(0, RECORD_SIZE);
      } else {
        storedRouteRecords[domain] = [span].concat(_toConsumableArray(new Array(RECORD_SIZE - 1).fill(BASE_SPAN)));
      }
    });
    sessionStorage.setObject(recordStorageKey, storedRouteRecords);
    return weightCalculation(storedRouteRecords).domain;
  });
};
export var removeRecords = function removeRecords() {
  sessionStorage.remove(recordStorageKey);
};
export var getCalculatedRoute = function getCalculatedRoute() {
  if (Object.keys(storedRouteRecords).length === 0) return currentDomain;
  return weightCalculation(storedRouteRecords).domain;
};